import SettingsTeamsPage from '@/components/pages/Settings/account/SettingsTeamsPage/SettingsTeamsPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/$workspaceName/$environment/account-settings/teams')({
  component: RouteComponent,
})

function RouteComponent() {
  return <SettingsTeamsPage />
}
